export default __webpack_public_path__ + "static/media/Freebooter's Helm of the Untamed.267ecbbc.jpg";